import { Component } from '@angular/core';
import { MetaDataService } from '../metadata.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert.service';
import { NGXLogger } from 'ngx-logger';
import { FeatureFlagsService } from '../feature-flags.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'tea-shop-fe-coming-soon',
  standalone: false,
  
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.css'
})
export class ComingSoonComponent {

  subscribeForm: FormGroup;
  isSubmitting = false;

  title$: Observable<string>;
  subtitle$: Observable<string>;

  private readonly endpoint = `${environment.apiHost ?? ''}/api/communications/newsletter/subscribe`;

  constructor(
    private readonly httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
    private featureFlagsService: FeatureFlagsService,
  ) { 
    this.metaDataService.updateMetadata({
      title: 'Coming Soon',
      image: '/assets/contact/sencha-logo.png',
    });
    this.subscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.title$ = this.featureFlagsService.getStringValue$('coming-soon-title', 'Coming Soon');
    this.subtitle$ = this.featureFlagsService.getStringValue$('coming-soon-subtitle', "We're brewing someting special for you.");
  }

  onSubmit() {
    if (this.subscribeForm.invalid) return;
    
    this.isSubmitting = true;
    this.subscribe(this.subscribeForm.value.email).subscribe({
      next: (result) => {
        this.logger.log('Subscribed successfully', result);
        this.subscribeForm.reset();
        this.isSubmitting = false;
        this.alertService.show({
          title: 'Subscribed: The First Steep',
          description: 'You have successfully subscribed to The First Steep digest.',
          type: 'success',
        })
      },
      error: (error: any) => {
        this.logger.log('Subscription failed', error);
        this.isSubmitting = false;
        this.alertService.show({
          title: 'Subscription Failed',
          description: 'There was a problem subscribing you to The First Steep digest. Please try again later.',
          type: 'warning',
        });
      }
    });
  }

  subscribe(email: string) {
    this.logger.log('Subscribing to defauly mailing list', email);
    return this.httpClient.post(this.endpoint, { email });
  }


}
